import moment from "moment-mini";
import HelperWithFormattingBase from "./HelperWithFormattingBase";

const DATE_INPUT_FORMATS = [
  "YYYY-MM-DDTHH:mm:ss.SSS",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD"
];

export class DateHelper extends HelperWithFormattingBase {
  renderMethods = {
    date_default: this.renderDefault,
    date_days_until_date: this.renderDaysUntilDate
  };

  renderDefault(value) {
    const date = moment(value, DATE_INPUT_FORMATS, true);

    if (!date.isValid()) {
      return value;
    }

    const hasTime =
      date.hour() !== 0 || date.minute() !== 0 || date.second() !== 0;

    return date.format(hasTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY");
  }

  renderDaysUntilDate(value, translate) {
    const date = moment(value);
    const today = moment();

    const daysDiff = date.diff(today, "days");
    const translateVars = {
      days: Math.abs(daysDiff)
    };

    let translatePhrase;

    if (daysDiff > 0) {
      translatePhrase = "in %{days} days";
    } else if (daysDiff === 0) {
      translatePhrase = "today";
    } else {
      translatePhrase = "%{days} days ago";
    }

    return translate(translatePhrase, translateVars);
  }
}

export default new DateHelper();
